module.exports = __webpack_public_path__ + "img/img_swiper_d.6d4664c3.jpg";